export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isStrongPassword = password => {
  // Regular expressions for different criteria
  const minLength = /^.{8,}$/; // At least 8 characters
  const onlyAlphabet = /^[A-Za-z\d!@#$%^&*(),.?":{}|<>]+$/; // Only English alphabet characters, numbers, and symbols
  const hasUppercase = /[A-Z]/; // At least one uppercase letter
  const hasLetter = /[A-Za-z]/; // At least one letter
  const hasNumber = /\d/; // At least one number
  const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/; // At least one symbol
  const noSpaces = /^\S*$/; // No spaces anywhere

  // Check if all criteria are met
  return (
    minLength.test(password) &&
    onlyAlphabet.test(password) &&
    hasUppercase.test(password) &&
    hasLetter.test(password) &&
    hasNumber.test(password) &&
    hasSymbol.test(password) &&
    noSpaces.test(password)
  );
};

export const containsSpecialCharsAndNumber = str => {
  const specialCharsAndNumbers = /[1-9`!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?~]/;
  const hindiChars = /^[\u0900-\u097F\s]+$/;
  return specialCharsAndNumbers.test(str) || hindiChars.test(str);
};